export default {
    PROJECT_RECEIVED: 'PROJECT_RECEIVED',
    PROJECT_REMOVED: 'PROJECT_REMOVED',
    PROJECT_RENAMED: 'PROJECT_RENAMED',
    PROJECT_COLOUR_CHANGED: 'PROJECT_COLOUR_CHANGED',
    PROJECT_UPDATED: 'PROJECT_UPDATED',
};
